export default function ProjectTimeline() {
  const steps = [
    { icon: 'ri-file-list-3-line', title: 'Заявка', desc: 'Вы оставляете заявку, мы связываемся в течение 24 часов и проводим предварительную консультацию' },
    { icon: 'ri-search-eye-line', title: 'Экспресс-диагностика', desc: 'Бесплатная диагностика текущей ситуации: анализ KPI, интервью с руководителем, выявление проблемных зон' },
    { icon: 'ri-file-search-line', title: 'Аудит', desc: 'Глубокий аудит компетенций команды, анализ воронки, прослушивание звонков, mystery shopping' },
    { icon: 'ri-file-edit-line', title: 'Подготовка программы', desc: 'Разработка индивидуальной программы обучения под выявленные точки роста и задачи бизнеса' },
    { icon: 'ri-presentation-line', title: 'Проведение обучения', desc: 'Очный или онлайн тренинг: 80% практики, реальные кейсы, отработка навыков' },
    { icon: 'ri-tools-fill', title: 'Практика', desc: 'Закрепление навыков через домашние задания, чек-листы и разбор реальных ситуаций' },
    { icon: 'ri-heart-pulse-line', title: 'Сопровождение', desc: 'Посттренинговые встречи: контроль выполнения, обратная связь, корректировка программы' },
    { icon: 'ri-bar-chart-grouped-line', title: 'Оценка результатов', desc: 'Сравнение KPI до и после обучения, расчёт ROI, фиксация достигнутых целей' },
    { icon: 'ri-rocket-2-line', title: 'Дальнейшее развитие', desc: 'План развития на следующие 6-12 месяцев, масштабирование лучших практик' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как проходит проект
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Прозрачный процесс от первой заявки до измеримых результатов — каждый этап согласован и понятен
        </p>

        {/* Десктоп — горизонтальный таймлайн */}
        <div className="hidden lg:block relative">
          <div className="absolute top-16 left-0 right-0 h-1 bg-teal-200 rounded-full"></div>
          <div className="grid grid-cols-9 gap-3">
            {steps.map((step, i) => (
              <div key={i} className="relative text-center">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 relative z-10 ring-4 ring-white">
                  <i className={`${step.icon} text-lg text-white`}></i>
                </div>
                <div className="mt-4 pt-4">
                  <h4 className="font-bold text-gray-900 text-xs mb-1">{step.title}</h4>
                  <p className="text-gray-500 text-[10px] leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Мобилка — вертикальный таймлайн */}
        <div className="lg:hidden space-y-0">
          {steps.map((step, i) => (
            <div key={i} className="flex gap-4">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${step.icon} text-lg text-white`}></i>
                </div>
                {i < steps.length - 1 && (
                  <div className="w-0.5 h-8 bg-teal-200"></div>
                )}
              </div>
              <div className="pb-6">
                <h4 className="font-bold text-gray-900 text-sm mb-1">{step.title}</h4>
                <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 text-center">
          <div className="inline-block bg-teal-50 border border-teal-200 rounded-xl px-8 py-5">
            <p className="text-lg md:text-xl font-bold text-teal-800">
              Весь цикл проекта — от диагностики до оценки результатов — занимает 4-8 недель
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}